import React from 'react';
import { Button, Col, Form, Input, Modal, Row } from 'antd';
const TagTypeCreationModal = props => {
  const {
    popupCreateTypeShow,
    isSubmitting,
    nameType,
    codeType,
    setState,
    submitCreateType
  } = props;
  return <Modal title="Create Tag Type" style={{
    top: 20
  }} visible={popupCreateTypeShow} onCancel={() => {
    setState({
      popupCreateTypeShow: false
    });
  }} className="createTag formTag" footer={null}>
      <Form name="basic" onFinish={submitCreateType}>
        <Form.Item className="form" label="Name" name="name" rules={[{
        required: true,
        message: 'Please input your name!'
      }]}>
          <Input data-testid="category-name-input" size="large" value={nameType} name="name" placeholder="Name" onChange={value => setState({
          nameType: value.target.value
        })} className="width-360" />
        </Form.Item>
        <Form.Item className="form" label="Code" name="code" rules={[{
        required: true,
        message: 'Please select your code!'
      }]}>
          <Input data-testid="category-code-input" size="large" value={codeType} name="code" placeholder="code" onChange={value => {
          setState({
            codeType: value.target.value
          });
        }} maxLength={4} className="width-360" />
        </Form.Item>
        <Row>
          <Col>
            <Form.Item>
              <Button data-testid="create-button" className="btn-save save" type="primary" htmlType="submit" loading={isSubmitting}>
                CREATE
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>
              <Button data-testid="cancel-button" className="btn-cancel cancel" loading={isSubmitting} onClick={() => setState({
              popupCreateTypeShow: false
            })}>
                CANCEL
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>;
};
export default TagTypeCreationModal;